// Gerado por tools/assets (`pnpm --filter @eldrun/assets models`). Não edite à mão.
// Fonte: tools/assets/src/models/manifest.ts; relatório em docs/assets/model-build-report.json.

/** Pacotes GLB em public/ (hash do conteúdo no nome: cache imutável). */
export const MODEL_BUNDLES = {
  ambiente: "/modelos/ambiente.04e577ff.glb",
  pois: "/modelos/pois.7a62315e.glb",
  detalhes: "/modelos/detalhes.1d706435.glb",
  itens: "/modelos/itens.72c04ec9.glb",
  estruturas: "/modelos/estruturas.209edf7f.glb",
} as const;

export type ModelBundle = keyof typeof MODEL_BUNDLES;

export interface ModelInfo {
  readonly bundle: ModelBundle;
  /** Triângulos por LOD (0 = perto). */
  readonly tris: readonly number[];
  /** Medidas do LOD 0 em metros (x, y, z), já normalizadas. */
  readonly size: readonly [number, number, number];
  /** Metros abaixo de y = 0. */
  readonly sink: number;
  /**
   * Paletas, na ordem dos atributos de cor (`color`, `color1`, `color2`); a primeira é a padrão.
   * As variantes de um mesmo recurso têm as mesmas paletas.
   */
  readonly palettes: readonly string[];
  /** Raio médio do tronco no pé, em metros (árvores). */
  readonly trunk?: number;
}

/** Malhas do pacote: `<id>@<lod>`, com uma cor por paleta. */
export const MODELS = {
  "rocha-a": { bundle: "ambiente", tris: [120, 40], size: [2, 1.402, 1.95], sink: 0.2, palettes: ["cinza"] },
  "rocha-b": { bundle: "ambiente", tris: [120, 40], size: [1.917, 1.222, 1.987], sink: 0.2, palettes: ["cinza"] },
  "rocha-c": { bundle: "ambiente", tris: [120, 40], size: [1.958, 1.261, 2], sink: 0.2, palettes: ["cinza"] },
  "betula-a": { bundle: "ambiente", tris: [396, 60], size: [3.879, 8, 3.268], sink: 0.15, palettes: ["normal", "dry"], trunk: 0.164 },
  "betula-b": { bundle: "ambiente", tris: [328, 59], size: [5.196, 8, 3.769], sink: 0.15, palettes: ["normal", "dry"], trunk: 0.218 },
  "macieira-a": { bundle: "ambiente", tris: [352, 60], size: [3.427, 5, 3.423], sink: 0.15, palettes: ["dry", "normal"], trunk: 0.281 },
  "macieira-b": { bundle: "ambiente", tris: [400, 60], size: [3.789, 5, 3.815], sink: 0.15, palettes: ["dry", "normal"], trunk: 0.129 },
  "pinheiro-a": { bundle: "ambiente", tris: [214, 60], size: [2.664, 8, 3.076], sink: 0.15, palettes: ["normal"], trunk: 0.164 },
  "pinheiro-b": { bundle: "ambiente", tris: [381, 60], size: [2.26, 8, 2.226], sink: 0.15, palettes: ["normal"], trunk: 0.161 },
  "amoreira-a": { bundle: "ambiente", tris: [400, 60], size: [5.153, 7, 6.543], sink: 0.15, palettes: ["dry", "normal"], trunk: 0.408 },
  "amoreira-b": { bundle: "ambiente", tris: [400, 60], size: [4.305, 7, 5.271], sink: 0.15, palettes: ["dry", "normal"], trunk: 0.408 },
  "cerejeira-a": { bundle: "ambiente", tris: [399, 60], size: [9.162, 9, 7.365], sink: 0.15, palettes: ["rosa", "amarela"], trunk: 0.302 },
  "cerejeira-b": { bundle: "ambiente", tris: [400, 60], size: [4.988, 9, 3.48], sink: 0.15, palettes: ["rosa", "amarela"], trunk: 0.248 },
  "carvalho-a": { bundle: "ambiente", tris: [392, 60], size: [8.778, 12, 6.973], sink: 0.15, palettes: ["normal"], trunk: 0.367 },
  "carvalho-b": { bundle: "ambiente", tris: [399, 59], size: [4.708, 12, 4.172], sink: 0.15, palettes: ["normal"], trunk: 0.332 },
  "ancia": { bundle: "ambiente", tris: [400, 60], size: [5.172, 17.611, 4.9], sink: 0.15, palettes: ["normal"], trunk: 0.874 },
  "pereira-a": { bundle: "ambiente", tris: [184, 60], size: [1.743, 3, 1.916], sink: 0.15, palettes: ["normal", "dry"], trunk: 0.07 },
  "pereira-b": { bundle: "ambiente", tris: [279, 59], size: [1.567, 3, 1.984], sink: 0.15, palettes: ["normal", "dry"], trunk: 0.065 },
  "veio-ferro": { bundle: "ambiente", tris: [320, 60], size: [1.918, 1.714, 2], sink: 0.2, palettes: ["cinza"] },
  "veio-prata": { bundle: "ambiente", tris: [320, 60], size: [1.618, 1.82, 2], sink: 0.2, palettes: ["cinza"] },
  "veio-carvao": { bundle: "ambiente", tris: [320, 60], size: [2, 1.418, 1.983], sink: 0.2, palettes: ["cinza"] },
  "parede": { bundle: "pois", tris: [219, 40], size: [2.6, 2.6, 0.65], sink: 0, palettes: ["padrao"] },
  "parede-meia": { bundle: "pois", tris: [150, 30], size: [1.3, 2.6, 0.65], sink: 0, palettes: ["padrao"] },
  "pilar": { bundle: "pois", tris: [136, 40], size: [1.5, 4, 1.5], sink: 0, palettes: ["padrao"] },
  "pilar-caido": { bundle: "pois", tris: [356, 60], size: [2.734, 1, 2.42], sink: 0, palettes: ["padrao"] },
  "entulho": { bundle: "pois", tris: [150, 30], size: [0.96, 0.5, 0.678], sink: 0, palettes: ["padrao"] },
  "tijolos": { bundle: "pois", tris: [132, 24], size: [0.75, 0.45, 0.637], sink: 0, palettes: ["padrao"] },
  "laje": { bundle: "pois", tris: [94, 20], size: [1.333, 0.1, 1.333], sink: 0.04, palettes: ["padrao"] },
  "barril": { bundle: "pois", tris: [207, 40], size: [0.886, 0.9, 0.886], sink: 0, palettes: ["padrao"] },
  "barril-deitado": { bundle: "pois", tris: [207, 40], size: [0.61, 0.6, 0.6], sink: 0, palettes: ["padrao"] },
  "caixote": { bundle: "pois", tris: [188, 24], size: [0.8, 0.8, 0.8], sink: 0, palettes: ["padrao"] },
  "barrica": { bundle: "pois", tris: [300, 40], size: [0.878, 1, 0.975], sink: 0, palettes: ["padrao"] },
  "banco": { bundle: "pois", tris: [172, 30], size: [0.75, 0.5, 0.75], sink: 0, palettes: ["padrao"] },
  "mesa": { bundle: "pois", tris: [247, 40], size: [1.406, 0.6, 1.499], sink: 0, palettes: ["padrao"] },
  "tocha": { bundle: "pois", tris: [200, 30], size: [0.289, 1.583, 0.301], sink: 0, palettes: ["padrao"] },
  "tabuas": { bundle: "pois", tris: [156, 30], size: [1.6, 0.118, 1.335], sink: 0, palettes: ["padrao"] },
  "lenha": { bundle: "pois", tris: [300, 40], size: [0.957, 0.584, 1.17], sink: 0, palettes: ["padrao"] },
  "pilar-rocha": { bundle: "pois", tris: [192, 60], size: [2.76, 4.6, 2.994], sink: 0.1, palettes: ["padrao"] },
  "penhasco": { bundle: "pois", tris: [214, 60], size: [4.592, 4.2, 5.135], sink: 0.1, palettes: ["padrao"] },
  "laje-rocha": { bundle: "pois", tris: [152, 40], size: [8, 1.401, 6.889], sink: 0, palettes: ["padrao"] },
  "pedregulho": { bundle: "pois", tris: [120, 40], size: [1.745, 1.2, 1.458], sink: 0.1, palettes: ["padrao"] },
  "pedra-solta": { bundle: "pois", tris: [32, 20], size: [0.825, 0.45, 0.69], sink: 0.05, palettes: ["padrao"] },
  "pedrinha": { bundle: "detalhes", tris: [30], size: [0.314, 0.218, 0.4], sink: 0, palettes: ["padrao"] },
  "laje-pedra": { bundle: "detalhes", tris: [36], size: [1.2, 0.346, 1.182], sink: 0, palettes: ["padrao"] },
  "muda-conifera": { bundle: "detalhes", tris: [58], size: [0.548, 1.2, 0.601], sink: 0, palettes: ["normal", "dry", "cold"] },
  "muda-folhosa": { bundle: "detalhes", tris: [87], size: [0.833, 1.2, 0.645], sink: 0, palettes: ["normal", "dry", "cold"] },
  "tabua": { bundle: "detalhes", tris: [28], size: [0.373, 0.14, 1.4], sink: 0, palettes: ["padrao"] },
  "item-machado": { bundle: "itens", tris: [300, 100], size: [0.407, 0.696, 0.149], sink: 0, palettes: ["padrao"] },
  "item-picareta": { bundle: "itens", tris: [300, 100], size: [0.75, 0.714, 0.108], sink: 0, palettes: ["padrao"] },
  "item-marreta": { bundle: "itens", tris: [300, 100], size: [0.607, 0.85, 0.334], sink: 0, palettes: ["padrao"] },
  "item-porrete": { bundle: "itens", tris: [300, 100], size: [0.457, 0.696, 0.31], sink: 0, palettes: ["padrao"] },
  "item-lanca": { bundle: "itens", tris: [299, 99], size: [0.133, 1.5, 0.118], sink: 0, palettes: ["padrao"] },
  "item-adaga": { bundle: "itens", tris: [300, 100], size: [0.153, 0.449, 0.052], sink: 0, palettes: ["padrao"] },
  "item-cajado": { bundle: "itens", tris: [300, 100], size: [0.361, 1.35, 0.183], sink: 0, palettes: ["padrao"] },
  "item-espada": { bundle: "itens", tris: [299, 99], size: [0.118, 0.95, 0.069], sink: 0, palettes: ["padrao"] },
  "item-arco": { bundle: "itens", tris: [300, 98], size: [0.202, 1, 0.047], sink: 0, palettes: ["padrao"] },
  "item-flecha": { bundle: "itens", tris: [64, 64], size: [0.083, 0.65, 0.071], sink: 0, palettes: ["padrao"] },
  "item-tora": { bundle: "itens", tris: [150, 60], size: [0.244, 0.245, 0.598], sink: 0, palettes: ["padrao"] },
  "item-lingote": { bundle: "itens", tris: [108, 60], size: [0.18, 0.112, 0.36], sink: 0, palettes: ["padrao"] },
  "item-minerio": { bundle: "itens", tris: [100, 60], size: [0.275, 0.3, 0.254], sink: 0, palettes: ["padrao"] },
  "item-corda": { bundle: "itens", tris: [150, 56], size: [0.4, 0.092, 0.376], sink: 0, palettes: ["padrao"] },
  "item-tocha": { bundle: "itens", tris: [300, 100], size: [0.117, 0.646, 0.126], sink: 0, palettes: ["padrao"] },
  "estrutura-bancada": { bundle: "estruturas", tris: [400], size: [1.3, 1, 0.75], sink: 0, palettes: ["padrao"] },
  "estrutura-bigorna": { bundle: "estruturas", tris: [316], size: [1.1, 0.68, 0.51], sink: 0, palettes: ["padrao"] },
  "estrutura-bau": { bundle: "estruturas", tris: [200], size: [0.719, 0.27, 0.555], sink: 0, palettes: ["padrao"] },
  "estrutura-bau-tampa": { bundle: "estruturas", tris: [200], size: [0.764, 0.424, 0.645], sink: 0, palettes: ["padrao"] },
  "estrutura-piso": { bundle: "estruturas", tris: [78, 40], size: [2, 0.2, 2], sink: 0.2, palettes: ["padrao"] },
  "estrutura-alicerce": { bundle: "estruturas", tris: [200, 40], size: [2, 2, 2], sink: 2, palettes: ["padrao"] },
} as const satisfies Record<string, ModelInfo>;

export type ModelId = keyof typeof MODELS;

/** Variantes de modelo por tipo de recurso (cada instância sorteia uma pelo seu id). */
export const RESOURCE_MODELS: Readonly<Partial<Record<string, readonly ModelId[]>>> = {
  "rocha": ["rocha-a", "rocha-b", "rocha-c"],
  "embauba": ["betula-a", "betula-b"],
  "cajueiro": ["macieira-a", "macieira-b"],
  "coqueiro": ["pinheiro-a", "pinheiro-b"],
  "acaizeiro": ["amoreira-a", "amoreira-b"],
  "ipe": ["cerejeira-a", "cerejeira-b"],
  "jatoba": ["carvalho-a", "carvalho-b"],
  "angelim": ["ancia"],
  "bananeira": ["pereira-a", "pereira-b"],
  "veio-ferro": ["veio-ferro"],
  "veio-prata": ["veio-prata"],
  "veio-carvao": ["veio-carvao"],
};

/** Modelo de cada peça das montagens dos POIs (F43); peça sem modelo usa a malha procedural. */
export const POI_PIECE_MODELS: Readonly<Partial<Record<string, ModelId>>> = {
  "parede": "parede",
  "parede-meia": "parede-meia",
  "pilar": "pilar",
  "pilar-caido": "pilar-caido",
  "entulho": "entulho",
  "tijolos": "tijolos",
  "laje": "laje",
  "barril": "barril",
  "barril-deitado": "barril-deitado",
  "caixote": "caixote",
  "barrica": "barrica",
  "banco": "banco",
  "mesa": "mesa",
  "tocha": "tocha",
  "tabuas": "tabuas",
  "lenha": "lenha",
  "pilar-rocha": "pilar-rocha",
  "penhasco": "penhasco",
  "laje-rocha": "laje-rocha",
  "pedregulho": "pedregulho",
  "pedra-solta": "pedra-solta",
};

/** Modelo de cada peça dos enfeites do chão (F44); peça sem modelo usa outro pacote ou a malha procedural. */
export const DETAIL_MODELS: Readonly<Partial<Record<string, ModelId>>> = {
  "pedrinha": "pedrinha",
  "laje-pedra": "laje-pedra",
  "muda-conifera": "muda-conifera",
  "muda-folhosa": "muda-folhosa",
  "tabua": "tabua",
};

/**
 * Modelo de cada forma de item (F47), com o punho na origem e o atributo `tint` (1 nas partes que
 * pegam a cor do tier); forma sem modelo usa outro pacote ou a malha procedural.
 */
export const ITEM_MODELS: Readonly<Partial<Record<string, ModelId>>> = {
  "machado": "item-machado",
  "picareta": "item-picareta",
  "marreta": "item-marreta",
  "porrete": "item-porrete",
  "lanca": "item-lanca",
  "adaga": "item-adaga",
  "cajado": "item-cajado",
  "espada": "item-espada",
  "arco": "item-arco",
  "flecha": "item-flecha",
  "tora": "item-tora",
  "lingote": "item-lingote",
  "minerio": "item-minerio",
  "corda": "item-corda",
  "tocha": "item-tocha",
};

/**
 * Modelo de cada forma de estrutura (F48) e das partes separadas dela (`<forma>:<parte>`: a tampa do
 * baú); forma sem modelo usa a malha procedural.
 */
export const STRUCTURE_MODELS: Readonly<Partial<Record<string, ModelId>>> = {
  "bancada": "estrutura-bancada",
  "bigorna": "estrutura-bigorna",
  "bau": "estrutura-bau",
  "bau:tampa": "estrutura-bau-tampa",
  "piso": "estrutura-piso",
  "alicerce": "estrutura-alicerce",
};

/**
 * Dobradiça de cada parte separada (`<forma>:<parte>`), no espaço do corpo, em metros: a origem do
 * modelo da parte, onde ela gira.
 */
export const STRUCTURE_HINGES: Readonly<Partial<Record<string, readonly [number, number, number]>>> = {
  "bau:tampa": [0, 0.2248, -0.2643],
};
